import { UserModel } from './../models/user.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CategoryLookupModel } from '../models/category-lookup.model';
import { CompanyinfoApiModel } from '../models/companyinfo-api.model';
import { IdNameMnemonicModel } from '../models/id-name-mnemonic.model';
import { ValConfigService } from './val-config.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ValService {
    constructor(private http: HttpClient, private config: ValConfigService) { }

    public GetToken = (
        data: { userName: string, password: string, cashRegisterId: string, channelId: string, extUserId: string }
    ): Observable<{ access_token: string, token_type: string, expires_in: number, login_type: number, wholesale: boolean }> => {
        return this.http.post<{ access_token: string, token_type: string, expires_in: number, login_type: number, wholesale: boolean }>
            (this.config.tokenUrl, data);
    }
    public GetUserCashRegisters = (data: { userName: string, password: string }
    ): Observable<Array<{ Id: string, Name: string, Country: number, IsDefault: boolean }>> => {
        return this.http.post<Array<{ Id: string, Name: string, Country: number, IsDefault: boolean }>>
            (this.config.userCashRegistersApiUrl, data);
    }
    public forgotPassword = (userName: string, email: string): Observable<void> => {
        return this.http.post<void>(this.config.forgotPasswordApiUrl, { UserName: userName, Email: email });
    }
    public getCategoriesLookup = (): Observable<Array<CategoryLookupModel>> => {
        return this.http.get<Array<CategoryLookupModel>>(this.config.categoriesLookupUrl);
    }
    public getPosLookup = (): Observable<Array<IdNameMnemonicModel>> => {
        return this.http.get<Array<IdNameMnemonicModel>>(this.config.posLookupUrl);
    }
    public getCompany = (): Observable<CompanyinfoApiModel> => {
        return this.http.get<CompanyinfoApiModel>(this.config.companyUrl);
    }
    public getUserinfo = (): Observable<UserModel> => {
        return this.http.get<UserModel>(this.config.userinfoUrl)
            .pipe(map(x => new UserModel(x.DisplayName, x.Telephone, x.MobilePhone, x.Email)));
    }
}
